import AboutUsPage from "../pages/AboutUsPage";
import DeveloperDetails from "../pages/DeveloperDetails";
import FindJobsPage from "../pages/FindJobsPage";
import SkillOrRole from "../pages/SkillOrRole";
import Home from "../pages/Home";
import StartHiring from "../pages/StartHiring";
import ContactUs from "../pages/ContactUs";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import LoginRegister from "../pages/LoginRegister";

export const ROUTES = Object.freeze({
    HOME: '/',
    FIND_JOBS: '/find-jobs',
    SHARE_DEVELOPER: '/developer/:slug',
    ABOUT_US: '/about',
    HIRE_DEVELOPER: '/hire/skill/:slug',
    HIRE_ROLE: '/hire/role/:slug',
    START_HIRING: '/start-hiring',
    CONTACT_US: '/contact-us',
    TERMS_OF_SERVICE: '/terms-of-service',
    PRIVACY_POLICY: '/privacy-policy',
    LOGIN_REGISTER: '/login-register',
})

const webRoutes = [
    {
        path: ROUTES.HOME,
        element: <Home />, 
        isPrivate: false,
    },
    {
        path: ROUTES.FIND_JOBS,
        element: <FindJobsPage />,
        isPrivate: false,
    },
    {
        path: ROUTES.SHARE_DEVELOPER,
        element: <DeveloperDetails />, 
        isPrivate: false,
    },
    {
        path: ROUTES.ABOUT_US,
        element: <AboutUsPage />,
        isPrivate: false,
    },
    {
        path: ROUTES.HIRE_DEVELOPER,
        element: <SkillOrRole />,
        isPrivate: false,
    },
    {
        path: ROUTES.HIRE_ROLE,
        element: <SkillOrRole />,
        isPrivate: false,
    },
    {
        path: ROUTES.START_HIRING,
        element: <StartHiring />,
        isPrivate: false,
    },
    {
        path: ROUTES.CONTACT_US,
        element: <ContactUs />,
        isPrivate: false,
    },
    {
        path: ROUTES.TERMS_OF_SERVICE,
        element: <TermsOfService />,
        isPrivate: false,
    },
    {
        path: ROUTES.PRIVACY_POLICY,
        element: <PrivacyPolicy />,
        isPrivate: false,
    },
    {
        path: ROUTES.LOGIN_REGISTER,
        element: <LoginRegister />,
        isPrivate: false,
    },
]

export default webRoutes;